const MTA = {
    // 自定义事件
    ID_PAY_WITH_REFERRER: 'paywithreferrer', // 是否是被邀请报名

    ID_TESLA_INVITE_MORE: 'teslainvitemore', // tesla弹窗上继续邀请按钮
    ID_TESLA_INVITE_CARD: 'teslainvitecard', // tesla弹窗上继续邀请按钮

    // 自定义漏斗
    ID_FUNNEL_JOIN_GENERAL: 'join-2', // 报名通用漏斗
    ID_FUNNEL_MONITOR_INVITE_CARD_JOIN: '13jieduichangya', // monitor_invite_card
    ID_FUNNEL_13_INVITE_CARD_1: '13jietongyongya', // invite_card_common-0509-01
    ID_FUNNEL_13_INVITE_CARD_2: '13jietongyongya-1', // invite_card_common-0509-02
    ID_FUNNEL_13_INVITE_CARD_3: '13jietongyongya-2', // invite_card_common-0514-01
    ID_FUNNEL_13_INVITE_CARD_4: '13jietongyongya-3', // invite_card_common-0514-02

    ID_FUNNEL_13_INVITE_CARD_5: '13jietongyongya-6', // invite_card_common-0520-01
    ID_FUNNEL_13_INVITE_CARD_6: '13jietongyongya-7', // invite_card_common-0520-02
    ID_FUNNEL_13_INVITE_CARD_7: '13jietongyongya-8', // invite_card_common-0520-03
    // todo: 存在bug，将两张邀请卡的数据统计到了一个漏斗
    ID_FUNNEL_13_INVITE_CARD_8: '13jietongyongya-3', // invite_card_common-0520-04
    ID_FUNNEL_13_INVITE_CARD_9: '13jietongyongya-9', // invite_card_common-0520-05
    ID_FUNNEL_13_INVITE_CARD_10: '13jietongyongya-10', // invite_card_common-0520-06

    ID_FUNNEL_13_TEAM_INVITE_CARD: '13jieduiwuyaoqi', // invite_card_team-0509
    ID_FUNNEL_13_TEAM_INVITE_CARD_2: '13jieduiwuyaoqi-1', // invite_card_team-0526-01
    ID_FUNNEL_13_TEAM_INVITE_CARD_3: '13jieduiwuyaoqi-2', // invite_card_team-0526-02

    ID_FUNNEL_NUMBER_CLOTH : '13jiehaomabubao', // 号码布报名 cansai4

    ID_FUNNEL_14_TEAM_INVITE_CARD_1: '14jieduiwuyaoqi',
    ID_FUNNEL_14_TEAM_INVITE_CARD_2: '14jieduiwuyaoqi-1',
    ID_FUNNEL_14_TEAM_INVITE_CARD_3: '14jieduiwuyaoqi-2',
    ID_FUNNEL_14_TEAM_INVITE_CARD_4: '14jieduiwuyaoqi-3',
    ID_FUNNEL_14_INVITE_CARD_1: '14jietongyongya',
    ID_FUNNEL_14_INVITE_CARD_2: '14jietongyongya-1',
    ID_FUNNEL_14_INVITE_CARD_3: '14jietongyongya-2',
    ID_FUNNEL_14_INVITE_CARD_4: '14jietongyongya-3',
    ID_FUNNEL_14_INVITE_CARD_5: '14jietongyongya-4',
    ID_FUNNEL_14_INVITE_CARD_6: '14jietongyongya-5',
    ID_FUNNEL_14_INVITE_CARD_7: '14jietongyongya-6',
    ID_FUNNEL_14_INVITE_CARD_8: '14jietongyongya-7',
    ID_FUNNEL_14_JMSXY: '14jiejiaomuyaoq',
    ID_FUNNEL_14_TESLA: '14jieteslabaomi',
};

export default MTA;
